import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Paper from '@material-ui/core/Paper';
import NumberFormat from 'react-number-format';
import { findIndex } from "lodash/array";
import LoadingOverlay from 'react-loading-overlay';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
const useStyles = makeStyles((theme) => ({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
    },
    
    paper: {
        background: "#339933",
        width:"100%",
        height:"50px",
    },
    formlabelpayment: {
        color:"white",
        margin:"10px",
        float:"right"
    }
}));

const BranchPurchasePOPayment = (props) => {
	
    const classes = useStyles();
    const dataInformation = props.location.dataInformation ? props.location.dataInformation : '';
    const itemInformation = props.location.itemInformation ? props.location.itemInformation : '';
    const newShippingCharge = props.location.newShippingCharge ? props.location.newShippingCharge : '';
    const notes = props.location.notes ? props.location.notes : '';
    const [POprice, setPOPrice] = useState(dataInformation.total.replace(",",""));
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [branchCurcode, setBranchCurcode] = useState(get_cookies('curcode'));
    const [userName, setUserName] = useState(get_cookies('username'));
    const [defaultPayment, setDefaultPayment] = useState({id:0,description:"Select Payment",status:0, clearing:"none"});
    const [clearPayment, setClearPayment] = useState({id:0,description:"Select Payment",status:0, clearing:"none"});
    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF
    const [isSaveBtnDisabled, setSaveBtnDisabled] = useState(false);
    //Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
    //Message Box EOF

	//ApiData Component useState SOF
	const [payment_list, loadPaymentDropDown] = useState([]);

    const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
	const get_paymentlist = () => {
		//get data for warehouse/location dropdown
		const apiUrl = process.env.REACT_APP_API_URL+'payment_list';
		axios.post(apiUrl).then((res) => {
			loadPaymentDropDown(res.data.payment_list);
		});
    };
    useEffect(() => {
        const newData = {...computedPayment};
        newData['topay_amount'] = POprice;
        newData['shipping_amount'] = newShippingCharge;
        newData['total_balance'] = parseFloat(POprice) + parseFloat(newShippingCharge);
        setComputedPayment({ ...newData });
    }, [POprice]);
	//ApiData Component useState EOF

	//Table Settings
	const [TABLE_DATA, setSelectedPaymentTable] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState({});
    const [computedPayment, setComputedPayment] = useState({});
	const onSelectPayment = () => {
        let newData = [...TABLE_DATA];
        
        const neededKeys = ["payamount", "payref", "paymentid"];
        if(neededKeys.every(key => Object.keys(selectedPayment).includes(key))){
            const tempObj = 
            {
                paymentid:selectedPayment.paymentid, 
                paymentname:selectedPayment.paymentname, 
                payamount:selectedPayment.payamount,
                payref:selectedPayment.payref
            }
            if(selectedPayment.paymentid == null || selectedPayment.paymentid == "" || selectedPayment.payamount == "" || selectedPayment.payref == "" || selectedPayment.payamount == 0){
                setShowMsgBox(true);
                setMsg("Please complete all required fields");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000);
            }else{
                let amttoadd = Number(computedPayment.total_payment) + Number(selectedPayment.payamount);
                // console.log("amt to add "+amttoadd);
                // console.log("to pay amount "+computedPayment.topay_amount);
                // console.log("selected amt "+selectedPayment.payamount);
                if(Number(amttoadd) > (Number(computedPayment.topay_amount) + Number(computedPayment.shipping_amount))){
                    setShowMsgBox(true);
                    setMsg("Payment is greater than to the amount to be settle");
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                    }, 3000);
                }else{
                    addOrUpdate(newData, tempObj);
                    clear_fields();
                }
            }
        }else{
            setShowMsgBox(true);
            setMsg("Please complete all required fields");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000);
        }
    };

    //Callback function of onSelectPayment
    useEffect(() => {
        computePayment();
        
    }, [TABLE_DATA]);

    const save_branchpo = () => {
        setSaveBtnDisabled(true);
		// const form_data = {
        //     dataInformation: dataInformation,
        //     itemInformation: itemInformation,
        //     newShippingCharge: newShippingCharge,
        //     notes: notes,
        //     payment_info: TABLE_DATA,
        //     hqidno: branchIdNo,
        //     curcode:branchCurcode,
        //     username:userName
        // }
        const formData = new FormData();

        formData.append('dataInformation', JSON.stringify(dataInformation));
        formData.append('itemInformation', JSON.stringify(itemInformation));
        formData.append('newShippingCharge', newShippingCharge);
        formData.append('notes', notes);
        formData.append('payment_info', JSON.stringify(TABLE_DATA));
        formData.append('idno', branchIdNo);
        formData.append('curcode', branchCurcode);
        formData.append('username', userName);
        setSaveBtnDisabled(true);
        setShowOverlay(true);
        setOverlayMsg('Processing Payment...');
        
        if(parseFloat(computedPayment.total_payment) < (parseFloat(computedPayment.topay_amount) + parseFloat(computedPayment.shipping_amount))){
            setShowMsgBox(true);
            setMsg("Insufficient Payment");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
                setShowOverlay(false);
                setOverlayMsg('');
            }, 3000)
            setSaveBtnDisabled(false);
        }else{
            const apiUrl = process.env.REACT_APP_API_URL+"savebranchpo";
            axios.post(apiUrl,formData).then((res) => {
                // console.log(res.data.result);
                if(res.data.result.success == 1){
                    setShowMsgBox(true);
                    setMsg(res.data.result.message);
                    setMsgType("success");
                    setTimeout(() => {
                        setShowMsgBox(false);
                        setShowOverlay(false);
                        setOverlayMsg('');
                        gobacktoHomepage();
                    }, 3000)
                }else{
                    setShowMsgBox(true);
                    setMsg(res.data.result.message);
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                        setShowOverlay(false);
                        setOverlayMsg('');
                    }, 3000)
                }
            });  
        }
    };

    const addOrUpdate = (array, item) => {
        const i = array.findIndex(_item => _item.paymentid === item.paymentid);
        if (i > -1) array[i].payamount = parseFloat(array[i].payamount) + parseFloat(item.payamount);
        else array.push(item); setSelectedPaymentTable([...array]);
    }

	const onInputChange = (event) => {
        // console.log(dropDownPaymentList);
		const newData = {...selectedPayment};
		newData[event.target.name]= event.target.value;
        setSelectedPayment({ ...newData });
    };
    
    const computePayment = () => {  
        let total_payment = 0;
        for (let index = 0; index < TABLE_DATA.length; index++) {
		    total_payment = parseFloat(total_payment) + parseFloat(TABLE_DATA[index].payamount);
        }
        const newData = {...computedPayment};
        const total_balance = (parseFloat(computedPayment.topay_amount) + parseFloat(computedPayment.shipping_amount)) - parseFloat(total_payment);
        newData['total_payment']= total_payment;
        newData['total_balance']= total_balance;
        setComputedPayment({ ...newData });
    }

	const refreshTable = () => {
		const newData = [...TABLE_DATA];
		setSelectedPaymentTable([...newData]);
    }

	const TABLE_COLUMNS = [
		{
		  name: 'paymentid',
		  label: 'ID',
		}, {
		  name: 'paymentname',
		  label: 'Payment Type',
		}, {
            name: 'payamount',
            label: 'Amount',
          }, {
		  name: 'payref',
		  label: 'Reference',
		} ,{
              name: "action",
              label: "Action",
              options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                  const rowIndex = tableMeta.rowIndex;
                  return (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => updateSelectedPayment(rowIndex)}
                    >
                      Delete
                    </Button>
        
                  );
                },
              },
            },
	];
	
	const TABLE_OPTION = {
        selectableRowsHideCheckboxes: true,
        // selectableRowsOnClick: true,
        print: false,
        filter: false,
        download: false,
        viewColumns: false,
        // onRowsDelete: (data) => {
        //   updateSelectedPayment(data.data[0].dataIndex);
        // },
	};

	const updateSelectedPayment = (index) => {
		TABLE_DATA.splice(index, 1);
		refreshTable();
	}
	//Table Settings EOF

	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        isLoggedIn();
        get_paymentlist();
        const newData = {...computedPayment};
        newData['topay_amount'] = POprice;
        newData['total_payment'] = 0;
        newData['shipping_amount'] = newShippingCharge;
        newData['total_balance'] = parseFloat(POprice.replace(",","")) + parseFloat(newShippingCharge.replace(",",""));
        setComputedPayment({ ...newData });
    }, []);
    //OnLoad Event/Data Fetching SOF

    //Api Functions SOF
        // Code blocks here
	//Api Request Functions EOF

	const dropDownPaymentList = {
		options: payment_list,
		getOptionLabel: (option) => option.description,
    };
    const numericOnly = (event) => {
        const re = /^\d*\.?\d*$/;
        if (event.target.value === '' || re.test(event.target.value)) {
            const newData = {...selectedPayment};
            newData[event.target.name]= event.target.value;
            setSelectedPayment({ ...newData });
        }
    }
    
    const clear_fields = () => {
        const newData = {...selectedPayment};
        newData['paymentid']= "";
        newData['paymentname']= "";
        newData['payamount']= "";
        newData['payref']= "";
        setSelectedPayment({ ...newData });
        setDefaultPayment(clearPayment);
    }

    const sales_home =  {
		pathname: "/sales/sales-order"
	}
    const gobacktoHomepage = () => {
        props.history.push(sales_home);
    }
	//FormData
	const [prep_data, setData] = useState({});
    //FormData EOF
	return (
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
                >
                <div className="page-header">
                    <div className="page-icon">
                        <LoyaltyTwoTone />
                    </div>
                    <Breadcrumbs aria-label="breadcrumb">
                        <NavLink to="/sales">
                            <h4 className="header-title">Sales</h4>
                        </NavLink>
                        <Typography color="textPrimary">Branch Purchase Order Payment</Typography>
                    </Breadcrumbs>
                </div>
                <div className="page-container">
                    <form noValidate autoComplete="off">
                        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
                        <Grid container spacing={2} className={classes.root}>
                            <Grid item xs={8}>
                                <Card>
                                    <CardContent>
                                        <h4 className={classes.title}>Payment Transaction</h4>
                                        <Grid container spacing={2}>
                                            <Grid xs={12}>
                                                <Autocomplete
                                                    value={defaultPayment}
                                                    options={payment_list}
                                                    getOptionLabel={option => option.description}
                                                    autoComplete
                                                    includeInputInList
                                                    className={classes.autoComplete}
                                                    name="paymentlist"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            margin="normal"
                                                            label="Payment Type"	
                                                            variant="outlined"
                                                            required="true"
                                                        />
                                                    )}
                                                    onChange={(event, newValue) => {
                                                        if (!newValue == "" || !newValue == null){
                                                            setDefaultPayment(newValue);
                                                            const newData = {...selectedPayment};
                                                            newData['paymentid']= JSON.stringify(newValue.id, null, ' ');
                                                            newData['paymentname']= newValue.description;
                                                            setSelectedPayment({ ...newData });
                                                        }
                                                    }}
                                                />
                                                <TextField
                                                    name="payamount"
                                                    label="Amount"
                                                    variant="outlined"
                                                    type="text"
                                                    margin="normal"
                                                    required="true"
                                                    value={selectedPayment.payamount}
                                                    className={classes.field}
                                                    onChange={numericOnly}
                                                />
                                                <TextField
                                                    name="payref"
                                                    label="Reference"
                                                    variant="outlined"
                                                    type="text"
                                                    margin="normal"
                                                    required="true"
                                                    value={selectedPayment.payref}
                                                    className={classes.field}
                                                    onChange={onInputChange}
                                                />
                                            </Grid>
                                            <Grid xs={12} >
                                                <div className={classes.button}>
                                                    <Button variant="outlined" color="primary" onClick={onSelectPayment} className={classes.buttonMarginRigh}>
                                                        Add Payment
                                                    </Button>
                                                </div>	
                                            </Grid>
                                            <Grid item xs={12}>										
                                                <MUIDataTable
                                                    title={
                                                        <div>
                                                            <div className="table-title">
                                                                Payment Details
                                                            </div>
                                                        </div>
                                                    }
                                                    id="table-grid"
                                                    data={TABLE_DATA}
                                                    columns={TABLE_COLUMNS}
                                                    options={TABLE_OPTION}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={4}>
                                <Card>
                                    <CardContent>
                                        <h4 className={classes.title}>Purchase Order Summary</h4>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                    
                                                <FormLabel className={classes.formlabelpayment}>
                                                    Total Amount To Pay: 
                                                    <NumberFormat value={computedPayment.topay_amount} displayType={'text'} decimalScale={2} thousandSeparator={true}/>
                                                </FormLabel>
                                                </Paper>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                    <FormLabel className={classes.formlabelpayment}>
                                                        Total Payment: 
                                                        <NumberFormat value={computedPayment.total_payment} displayType={'text'} thousandSeparator={true}/>
                                                    </FormLabel>
                                                </Paper>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                    <FormLabel className={classes.formlabelpayment}> 
                                                        Shipping: 
                                                        <NumberFormat value={computedPayment.shipping_amount} displayType={'text'} thousandSeparator={true}/>
                                                    </FormLabel>
                                                </Paper>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                    <FormLabel className={classes.formlabelpayment}>
                                                        Total Balance: 
                                                        <NumberFormat value={computedPayment.total_balance} displayType={'text'} thousandSeparator={true}/>
                                                    </FormLabel>
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs="12" className={classes.buttonContainer}>
                                <Button 
                                    variant="contained" 
                                    color="primary"
                                    disabled={isSaveBtnDisabled}
                                    onClick={save_branchpo}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </LoadingOverlay>
		</div>
	);
};

export default BranchPurchasePOPayment;
